<script>
import { APP_USER_HEDA_SIZE } from "@/config/app.config";
import AccountExit from "@/layouts/website/components/WH/WFRC/AccountExit.vue";

import { mapGetters } from "vuex";

export default {
  name: "AccountInfo",
  components: { AccountExit },
  computed: {
    ...mapGetters(["is_login", "show_user_head", "show_user_name", "user_level"]),
    user_head_size: function () {
      return APP_USER_HEDA_SIZE;
    },
  },
  data() {
    return {
      is_show: false,
      is_show_status: -1,
    };
  },
  methods: {
    goAuthentication() {
      const data = {
        del_flag: 0,
        ordering: '-id',
        member: this.$store.state.user.user.member.id
      }
      HTTP.get('member_apply', data).then(res => {
        if(res.code == 0) {
          if(res.data.results.length > 0){
            this.$router.push({
              path: "/homes/authentication-process",
              query: {
                status: res.data.results[0].status,
              }
            });
          }else {
            this.$router.push("/homes/authentication");
          }
        }
      })
    },
    changeUserInfo() {
      console.log("changeUserInfo");
      if (!this.is_login) return this.$router.push("/login");
    },
  },
  mounted() {
    if(this.$store.state.user.token) {
      this.avatar = this.$store.state.user.user.member.avatar
      const data = {
        del_flag: 0,
        ordering: '-id',
        member: this.$store.state.user.user.member.id
      }
      HTTP.get('member_apply', data).then(res => {
        if(res.code == 0){
          if(res.data.results.length > 0){
            if(res.data.results[0].status == 1){
              this.is_show = false
            }else {
              this.is_show_status = res.data.results[0].status
              this.is_show = true
            }
          }else {
            this.is_show_status = -1
            this.is_show = true
          }
        }
      })
    }
  }
};
</script>

<template>
  <div class="account-info">
    <div class="user-info" @click.stop="changeUserInfo">
      <img class="user-head" :src="show_user_head" />
      <div class="user-name">
        <span v-if="is_show && is_login && user_level==0 && is_show_status == -1" @click.stop="goAuthentication" class="user-tip">去认证</span>
        <span v-if="is_show && is_login && user_level==0 && is_show_status == 0 || is_show_status == 2" @click.stop="goAuthentication" class="user-tip">认证中</span>
        <span class="user-name-text">{{ show_user_name }}</span>
      </div>
    </div>

    <AccountExit v-if="is_login"></AccountExit>
  </div>
</template>

<style lang="scss" scoped>
.account-info {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;

  .user-info {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 4px;

    &:hover {
      .user-head {
        border-color: rgba(66,185,131,0.31);
      }

      .user-name {
        color: green;
      }
    }

    .user-head {
      width: v-bind(user_head_size);
      height: v-bind(user_head_size);
      border-radius: 50%;
      transition: border-color 0.1s ease-in-out;
      cursor: pointer;
    }

    .user-name {
      max-width: 3em;
      text-overflow: ellipsis;
      transition: color 0.1s ease-in-out;
      cursor: pointer;
      font-size: 15px;
      position: relative;

      .user-tip {
        position: absolute;
        right: 0;
        bottom: 100%;
        background-color: red;
        color: #ffffff;
        font-size: 10px;
        line-height: 1.6em;
        padding: 2px 8px;
        border-radius: 10px;
      }
      .user-name-text{
        width: 70px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
      }
    }
  }
}
</style>
